import { render, staticRenderFns } from "./addPlanDiglog.vue?vue&type=template&id=6b053654&scoped=true"
import script from "./addPlanDiglog.vue?vue&type=script&lang=js"
export * from "./addPlanDiglog.vue?vue&type=script&lang=js"
import style0 from "./addPlanDiglog.vue?vue&type=style&index=0&id=6b053654&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b053654",
  null
  
)

export default component.exports